import React, { FC } from 'react';
import { PricingTable } from 'src/components/Pricing/PricingTable';

import {
    printingPrices,
    embroideryPrices,
    bigBackPrice,
    bigBackTypes,
    printingQuantity,
    embroideryQuantity,
    irishPrintingPrices,
    irishEmbroideryPrices,
    irishBigBackPrice,
} from './pricesData';
import classes from './Pricing.scss';

export const Prices: FC<{ isIrishUser: boolean }> = ({ isIrishUser }) => (
    <div className={classes.pricingContainer}>
        <h2 className={classes.subHeader}>Prices</h2>
        <div className={classes.tablesContainer}>
            <PricingTable
                title="Printing"
                columnTitle1="Min. Quantity"
                columnTitle2="Price Per Application"
                columnData1={printingQuantity}
                columnData2={isIrishUser ? irishPrintingPrices : printingPrices}
            />
            <PricingTable
                title="Embroidery"
                columnTitle1="Quantity"
                columnTitle2="Price Per Application"
                columnData1={embroideryQuantity}
                columnData2={isIrishUser ? irishEmbroideryPrices : embroideryPrices}
            />
            <PricingTable
                title="Big Back"
                columnTitle1="Type"
                columnTitle2="Price Per Application"
                columnData1={bigBackTypes}
                columnData2={isIrishUser ? irishBigBackPrice : bigBackPrice}
            />
        </div>
        <div className={classes.smallTextParagraph}>
            Bulk discounts are available on larger orders, so please don't hesitate to contact us for the best value
            prices tailored to your needs.
        </div>
    </div>
);
